import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import type { ISODate } from '../../common/utils';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const postDuplicateVisualValidationTimeSeriesComparison = ({
  externalCode,
  ...data
}: {
  externalCode: string;
  valueDateFrom: ISODate;
  valueDateTo: ISODate;
  dataObjectVersionIds1: number[];
  dataObjectVersionIds2: number[];
  rule1Code: string;
  rule2Code: string;
  outliers: boolean;
  hp: boolean;
}) => {
  let url: string = ValidationDashboardUrl.TIME_SERIES_COMPARISON_DUPLICATE;
  if (data.hp) {
    url = ValidationDashboardUrl.HODRICK_PRESCOTT_COMPARISON_DUPLICATE;
  } else if (data.outliers) {
    url = ValidationDashboardUrl.OUTLIERS_COMPARISON_DUPLICATE;
  }
  return apiClient
    .post<{
      externalCode: string;
    }>(
      expand(url, {
        externalCode,
      }),
      data,
    )
    .then((response) => response.data);
};

export const useDuplicateVisualValidationTimeSeriesComparisonMutation =
  createApiMutationHook(
    ['duplicateVisualValidationTimeSeriesComparison'],
    postDuplicateVisualValidationTimeSeriesComparison,
  );
